import { LOCALE } from '../../../i18n/LOCALE'
import { TENANT } from '../../../tenant/tenantTypes'

export const EXPERIMENT_OWN_BRANDS_OVERLAY_PRODUCTS_MAP: Partial<
  Record<TENANT, Record<string, string>>
> = {
  [TENANT.AT]: {
    '00361784': '16623967',
    '00495970': '17396686',
    '10048806': '19143564',
    '10950145': '17396717',
    '12472514': '17825271',
    '13476520': '17756736',
    '13512730': '19204627',
    '18006664': '17447343',
  },
  [TENANT.IT]: {
    IT904982624: '16665693',
    IT905972081: 'IT200001910',
    IT906706041: '16623967',
    IT933543807: '17396686',
    IT975813813: 'IT200000945',
    IT976597070: '18362910',
    IT976785497: '18239948',
    IT988654657: 'IT200003550',
  },
}

export const EXPERIMENT_OWN_BRANDS_OVERLAY_SHOW_TIMEOUT = 7000
export const EXPERIMENT_OWN_BRANDS_OVERLAY_ADD_TO_CART_FORM_ID =
  'experiment-own-brands-overlay-add-to-cart-form-id'

export const EXPERIMENT_OWN_BRANDS_OVERLAY_TITLE: Partial<
  Record<LOCALE, { v1: string; v2: string }>
> = {
  [LOCALE.DE_AT]: {
    v1: 'Hohe Qualität, niedriger Preis: Entdecken Sie unsere Eigenmarke',
    v2: 'Die günstigere Alternative unserer Eigenmarke',
  },
  [LOCALE.IT_IT]: {
    v1: 'Qualità e Risparmio: Scopri i nostri Brand',
    v2: 'La tua alternativa conveniente: i nostri brand',
  },
}

export const EXPERIMENT_OWN_BRANDS_OVERLAY_BUTTON_TEXT: Partial<
  Record<LOCALE, string>
> = {
  [LOCALE.DE_AT]: 'Jetzt entdecken',
  [LOCALE.IT_IT]: 'Scopri ora',
}
